/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type TAG = "ADMIN" | "EXPERT" | "FEATURED" | "MODERATOR" | "STAFF" | "UNANSWERED" | "%future added value";
export type UserTagsContainer_comment = {
    readonly tags: ReadonlyArray<{
        readonly code: TAG;
    }>;
    readonly " $refType": "UserTagsContainer_comment";
};
export type UserTagsContainer_comment$data = UserTagsContainer_comment;
export type UserTagsContainer_comment$key = {
    readonly " $data"?: UserTagsContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"UserTagsContainer_comment">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserTagsContainer_comment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "Tag",
            "kind": "LinkedField",
            "name": "tags",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Comment",
    "abstractKey": null
} as any);
(node as any).hash = '2604c8bd359b8d22c8ccbf2eb2e682c9';
export default node;
